export default __webpack_public_path__ + "static/media/linux.3db32b95.png";